import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FunctionalDynamicAssessmentProvider } from '../../../functionalDynamicAssessment/context';
import { FDALayout } from '../../../functionalDynamicAssessment/components/FDALayout';
import { useFunctionalDynamicAssessment } from '../../../functionalDynamicAssessment/hooks/useFunctionalDynamicAssessment';
import { Loader } from '../../../ui/components';
import { enqueueSnackbar } from 'notistack';

export const PatientFunctionalDynamicAssessmentScreen: FC = () => {
  const [params] = useSearchParams();

  const fdaId = params.get('fdaId');
  const { data, authToken, loading, error } =
    useFunctionalDynamicAssessment(fdaId);

  // // Handle API loading phase
  if (loading) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', height: '90vh' }}
      >
        <Loader />
      </div>
    );
  }

  if (error) {
    enqueueSnackbar(error, { variant: 'error' });
    return null;
  }

  if (!data || !authToken) {
    return null;
  }

  return (
    <FunctionalDynamicAssessmentProvider fdaData={data} authToken={authToken}>
      <FDALayout />
    </FunctionalDynamicAssessmentProvider>
  );
};
